import Model from "../Model";

class RepresentantsZone extends Model{

    buildUrl ({ param }) {
        return ['allemployeeview/getallemployeedatabyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantsZone;